import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconSaturationSizeS from './IconSaturation_size_s';

const props: CreateIconArguments = {
  l: IconSaturationSizeS,
  m: IconSaturationSizeS,
  s: IconSaturationSizeS,
  xs: IconSaturationSizeS,
  name: 'IconSaturation',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
